export default __webpack_public_path__ + "static/media/wht-cat-5.926eda47.svg";